<router-outlet *ngIf="razorpay"></router-outlet>
<app-mobile-payment *ngIf="razorpay1"></app-mobile-payment>
